const hooks = new Map<string, () => Promise<boolean>>()
const unsavedFlags = new Map<string, boolean>()

export const tabBeforeClose = {
  register(key: string, hook: () => Promise<boolean>) {
    hooks.set(key, hook)
  },
  unregister(key: string) {
    hooks.delete(key)
  },
  get(key: string) {
    return hooks.get(key)
  },
  markUnsaved(key: string, flag: boolean) {
    unsavedFlags.set(key, flag)
  },
  isUnsaved(key: string) {
    return !!unsavedFlags.get(key)
  },
  clearUnsaved(key: string) {
    unsavedFlags.delete(key)
  }
}
